import { Box, styled } from '@mui/material';

export const AnimatedContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: '12px',
  marginBottom: '16px',
  minHeight: '300px',
  transition: 'all 0ms',
  '&.removing': {
    opacity: 0,
    minHeight: 0,
    maxHeight: 0,
    marginBottom: '0px',
    overflow: 'hidden',
    transition: 'all 350ms ease-in-out',
  },
});

export const LocalizationsVersionContainer = styled(Box)({
  display: 'flex',
  width: '100%',
  flexDirection: 'column',
  gap: '26px',
  marginBottom: '16px',
});
